import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgMilkShake = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 21"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="m13.27 12.25.077.004a.75.75 0 0 1 0 1.492l-.077.004H2.73a.75.75 0 0 1 0-1.5z" />
      <path d="M13.25 8.172a.885.885 0 0 0-.02-.184v-.001A4.12 4.12 0 0 0 9.205 4.75h-2.3a4.251 4.251 0 0 0-4.12 3.203l-.006.022-.004.017a.839.839 0 0 0-.025.205v.733l1.839 10.114.012.043c.036.096.129.163.234.163h6.33a.25.25 0 0 0 .246-.205L13.25 8.93zm1.5.828a.75.75 0 0 1-.012.133l-1.851 10.18a1.75 1.75 0 0 1-1.722 1.437h-6.33c-.846 0-1.57-.606-1.722-1.436L1.262 9.133A.75.75 0 0 1 1.25 9v-.803c0-.192.023-.384.07-.571l.001-.005.004-.017a5.751 5.751 0 0 1 5.58-4.354h2.3a5.62 5.62 0 0 1 5.434 4.18l.057.24.001.003c.036.165.053.333.053.5z" />
      <path d="M15 8.25a.75.75 0 0 1 0 1.5H1a.75.75 0 1 1 0-1.5z" />
      <path d="M9.115 1.522A1.751 1.751 0 0 1 11.123.28l.19.048 2.908.896a.75.75 0 0 1-.367 1.452l-.075-.019-2.907-.895a.25.25 0 0 0-.32.197v.001L8.696 13.123a.75.75 0 0 1-1.48-.246L9.072 1.714z" />
    </svg>
  );
};
export default SvgMilkShake;
